import React from 'react';
import cx from 'classnames';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
  container: {
    marginBottom: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    }
  },
  root: {
    'padding': 0,
    'flex': 1,
    '&:hover': {
      backgroundColor: 'transparent',
    },
    [theme.breakpoints.down('sm')]: {
      marginRight: theme.spacing(1)
    }
  },
  wrap: {
    'display': 'flex',
    'marginBottom': 4,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flex: 1,
    }
  },
  label: {
    fontSize: 14,
    marginRight: 'auto',
  },
  btn: {
    minWidth: 55,
    borderRadius: 4,
    marginLeft: theme.spacing(1),
    color: theme.palette.text.secondary,
    fontSize: 14,
    borderColor: 'rgba(132, 132, 141, 0.2)',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      minWidth: 45,
      width: '100%',
    }
  },
  selectedBtn: {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.primary['200'],
    fontWeight: 700,
  },
}));

function StyledRadio(props) {
  const classes = useStyles();

  return (
    <Radio
      className={classes.root}
      disableRipple
      color="default"
      checkedIcon={
        <Button className={cx(classes.btn, classes.selectedBtn)} variant="contained" color="primary">
          {props.value}
        </Button>
      }
      icon={
        <Button className={classes.btn} variant="outlined" color="default">
          {props.value}
        </Button>
      }
      {...props}
    />
  );
}

const ScoreInput = ({ label, value, ...other }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <Typography className={classes.label}>
        {label}
      </Typography>
      <div className={classes.wrap}>
        <StyledRadio value={1} checked={String(value) === '1'} {...other} />
        <StyledRadio value={2} checked={String(value) === '2'} {...other} />
        <StyledRadio value={3} checked={String(value) === '3'} {...other} />
        <StyledRadio value={4} checked={String(value) === '4'} {...other} />
        <StyledRadio value={5} checked={String(value) === '5'} {...other} />
      </div>
    </div>
  );
};

export default ScoreInput;
